import { useTranslation } from 'react-i18next';

const UnknownCoverage = () => {
    const { t } = useTranslation();

    return <>{t('claim.planMap.unknownCoverage')}</>;
};

export default UnknownCoverage;
